import { Form, Select } from 'antd'
import * as React from 'react'
import { FC } from 'react'

const status = [
    {
        value: 'Создан',
        label: 'Создан',
    },
    {
        value: 'Прибыл',
        label: 'Прибыл',
    },
    // Выставляются приёмкой позиций в «Приход → Материалы»
    {
        value: 'В приемке',
        label: 'В приемке',
        disabled: true,
    },
    {
        value: 'Завершен',
        label: 'Завершен',
        disabled: true,
    },
]

interface StatusProps {
    onChange?: () => void
}

const Status: FC<StatusProps> = ({ onChange }) => {
    return (
        <Form.Item name={'receiptStatus'} label={'Статус'}>
            <Select options={status} style={{ width: '100%' }} onChange={onChange} />
        </Form.Item>
    )
}

export default Status
